



















import {Component, Prop, Watch} from 'vue-property-decorator';
import BaseComponent from '@/core/components/BaseComponent';
import {Client} from "@/core/services/MedicaPro/models";
import DateView from "@/components/Shared/DateView.vue";

@Component({
    components: {DateView}
})
export default class ClientDetailsPageHeaderView extends BaseComponent {

    // Bindings to parent
    @Prop() item!: Client;

    // Bindings to view
    public isReady = false;
    public uuid = '';
    public name = '';
    public birthday: Date | null = null;

    public mounted() {
        this.renderView();
    }

    public beforeDestroy() {
        super.beforeDestroy();
    }

    private renderView() {
        this.uuid = this.item.uuid ?? '';
        this.name = this.item.name;
        this.birthday = this.item.birthday?.length ? new Date(this.item.birthday) : null;
        this.isReady = true;
    }

}
